module.exports = __webpack_public_path__ + "static/media/tabs.92033496.less";